module.exports = __webpack_public_path__ + "static/media/19ESCAP24.c9d9f72a.jpg";